const PMNumbers = {
    "GPOM": [],
    "In-House": [],
    "BTL Fresno Yard": [],
    "BTL Hayward Yard": [],
    "BTL Sacramento Yard": [],
    
    "North Coast": [], // region 1
    "North Valley & Sierra": [], // region 2
    "Bay Area": [], // region 3
    "South Bay & Central Coast": [], // region 4
    "Central Valley": [], // region 5
    
    "Richmond": [],

    "San Jose": [
        {value: "42910671", name: "SJ Locate & Mark - Dist"}, 
        {value: "42910672", name: "SJ Locate & Mark - GT"}, 
        {value: "42910673", name: "SJ After Hours Locate & Mark"}, 
        {value: "42910674", name: "SJ L&M Standby - Dist"}, 
        {value: "42910675", name: "SJ L&M Standby - GT"}, 
        {value: "42708330", name: "SJ L&M Dist -  Field Meet"}, 
        {value: "42708342", name: "SJ L&M Trans - Field Meet"}, 
    ],
    "Cinnebar": [
        {value: "42910676", name: "CI Locate & Mark - Dist"}, 
        {value: "42910677", name: "CI Locate & Mark - GT"}, 
        {value: "42910678", name: "CI After Hours Locate & Mark"}, 
        {value: "42910679", name: "CI L&M Standby - Dist"}, 
        {value: "42910680", name: "CI L&M Standby - GT"}, 
        {value: "42910738", name: "CI L&M Dist -  Field Meet"}, 
        {value: "42910681", name: "CI L&M Trans - Field Meet"},                                  
    ],
    "Vacaville": [
        {value: "42910629", name: "VA Locate & Mark - Dist"}, 
        {value: "42910630", name: "VA Locate & Mark - GT"}, 
        {value: "42910631", name: "VA After Hours Locate & Mark"}, 
        {value: "42910632", name: "VA L&M Standby - Dist"}, 
        {value: "42910633", name: "VA L&M Standby - GT"}, 
        {value: "42910634", name: "VA L&M Dist -  Field Meet"}, 
        {value: "42910635", name: "VA L&M Trans - Field Meet"},             
    ],
    "Central Coast": [
        {value: "42910374", name: "CC Locate & Mark - Dist"},
        {value: "42910376", name: "CC After Hours Locate & Mark"},
        {value: "42910377", name: "CC L&M Standby - Dist"},
        {value: "42910378", name: "CC L&M Standby - GT"},
        {value: "42708354", name: "CC L&M Dist -  Field Meet"},
        {value: "42708356", name: "CC L&M Trans - Field Meet"},
    ],
    "Los Padres": [
        {value: "42910379", name: "LP Locate & Mark - Dist"}, 
        {value: "42910620", name: "LP Locate & Mark - GT"}, 
        {value: "42910621", name: "LP After Hours Locate & Mark"}, 
        {value: "42910622", name: "LP L&M Standby - Dist"}, 
        {value: "42910623", name: "LP L&M Standby - GT"}, 
        {value: "42708323", name: "LP L&M Dist -  Field Meet"}, 
        {value: "42735664", name: "LP L&M Trans - Field Meet"},             
    ],
    "Sacramento": [
        {value: "42910624", name: "SA Locate & Mark - Dist"}, 
        {value: "42910625", name: "SA Locate & Mark - GT"}, 
        {value: "42910626", name: "SA After Hours Locate & Mark"}, 
        {value: "42910627", name: "SA L&M Standby - Dist"}, 
        {value: "42910628", name: "SA L&M Standby - GT"}, 
        {value: "42708328", name: "SA L&M Dist -  Field Meet"}, 
        {value: "42708348", name: "SA L&M Trans - Field Meet"},             
    ],
    "San Francisco": [
        {value: "42910636", name: "SF Locate & Mark - Dist"}, 
        {value: "42910637", name: "SF Locate & Mark - GT"}, 
        {value: "42910638", name: "SF After Hours Locate & Mark"}, 
        {value: "42910639", name: "SF L&M Standby - Dist"}, 
        {value: "42910640", name: "SF L&M Standby - GT"}, 
        {value: "42708329", name: "SF L&M Dist -  Field Meet"}, 
        {value: "42708337", name: "SF L&M Trans - Field Meet"},             
    ],
    "Peninsula": [
        {value: "42910641", name: "PN Locate & Mark - Dist"}, 
        {value: "42910642", name: "PN Locate & Mark - GT"}, 
        {value: "42910643", name: "PN After Hours Locate & Mark"}, 
        {value: "42910644", name: "PN L&M Standby - Dist"}, 
        {value: "42910645", name: "PN L&M Standby - GT"}, 
        {value: "42708327", name: "PN L&M Dist -  Field Meet"}, 
        {value: "42708336", name: "PN L&M Trans - Field Meet"},                      
    ],
    "De Anza": [
        {value: "42910646", name: "DA Locate & Mark - Dist"}, 
        {value: "42910647", name: "DA Locate & Mark - GT"}, 
        {value: "42910648", name: "DA After Hours Locate & Mark"}, 
        {value: "42910649", name: "DA L&M Standby - Dist"}, 
        {value: "42910650", name: "DA L&M Standby - GT"}, 
        {value: "42708079", name: "DA L&M Dist -  Field Meet"}, 
        {value: "42708341", name: "DA L&M Trans - Field Meet"}, 
    ],
    "Mission": [
        {value: "42910651", name: "MI Locate & Mark - Dist"}, 
        {value: "42910652", name: "MI Locate & Mark - GT"}, 
        {value: "42910653", name: "MI After Hours Locate & Mark"}, 
        {value: "42910654", name: "MI L&M Standby - Dist"}, 
        {value: "42910655", name: "MI L&M Standby - GT"}, 
        {value: "42708324", name: "MI L&M Dist -  Field Meet"}, 
        {value: "42708340", name: "MI L&M Trans - Field Meet"}, 
    ],
    "Diablo": [
        {value: "42910656", name: "DI Locate & Mark - Dist"}, 
        {value: "42910657", name: "DI Locate & Mark - GT"}, 
        {value: "42910658", name: "DI After Hours Locate & Mark"}, 
        {value: "42910659", name: "DI L&M Standby - Dist"}, 
        {value: "42910660", name: "DI L&M Standby - GT"}, 
        {value: "42708355", name: "DI L&M Dist -  Field Meet"}, 
        {value: "42708338", name: "DI L&M Trans - Field Meet"}, 
    ],
    "East Bay": [
        {value: "42910661", name: "EB Locate & Mark - Dist"}, 
        {value: "42910662", name: "EB Locate & Mark - GT"}, 
        {value: "42910663", name: "EB After Hours Locate & Mark"}, 
        {value: "42910664", name: "EB L&M Standby - Dist"}, 
        {value: "42910665", name: "EB L&M Standby - GT"}, 
        {value: "42708320", name: "EB L&M Dist -  Field Meet"}, 
        {value: "42708339", name: "EB L&M Trans - Field Meet"}, 
    ],
    "North Bay": [
        {value: "42910666", name: "NB Locate & Mark - Dist"}, 
        {value: "42910667", name: "NB Locate & Mark - GT"}, 
        {value: "42910668", name: "NB After Hours Locate & Mark"}, 
        {value: "42910669", name: "NB L&M Standby - Dist"}, 
        {value: "42910670", name: "NB L&M Standby - GT"}, 
        {value: "42708325", name: "NB L&M Dist -  Field Meet"}, 
        {value: "42708350", name: "NB L&M Trans - Field Meet"}, 
    ],
    "Fresno": [
        {value: "42910682", name: "FR Locate & Mark - Dist"}, 
        {value: "42910683", name: "FR Locate & Mark - GT"}, 
        {value: "42910684", name: "FR After Hours Locate & Mark"}, 
        {value: "42910685", name: "FR L&M Standby - Dist"}, 
        {value: "42910686", name: "FR L&M Standby - GT"}, 
        {value: "42708321", name: "FR L&M Dist -  Field Meet"}, 
        {value: "42708343", name: "FR L&M Trans - Field Meet"}, 
    ],
    "Kern/Bakersfield": [
        {value: "42910687", name: "KN Locate & Mark - Dist"}, 
        {value: "42910688", name: "KN Locate & Mark - GT"}, 
        {value: "42910689", name: "KN After Hours Locate & Mark"}, 
        {value: "42910690", name: "KN L&M Standby - Dist"}, 
        {value: "42910691", name: "KN L&M Standby - GT"}, 
        {value: "42708322", name: "KN L&M Dist -  Field Meet"}, 
        {value: "42708344", name: "KN L&M Trans - Field Meet"}, 
    ],
    "Stockton": [
        {value: "42910692", name: "ST Locate & Mark - Dist"}, 
        {value: "42910693", name: "ST Locate & Mark - GT"}, 
        {value: "42910694", name: "ST After Hours Locate & Mark"}, 
        {value: "42910695", name: "ST L&M Standby - Dist"}, 
        {value: "42910696", name: "ST L&M Standby - GT"}, 
        {value: "42708332", name: "ST L&M Dist -  Field Meet"}, 
        {value: "42708345", name: "ST L&M Trans - Field Meet"}, 
                  
    ],
    "Yosemite (Modesto)": [
        {value: "42910697", name: "YO Locate & Mark - Dist"}, 
        {value: "42910698", name: "YO Locate & Mark - GT"}, 
        {value: "42910699", name: "YO After Hours Locate & Mark"}, 
        {value: "42910700", name: "YO L&M Standby - Dist"}, 
        {value: "42910701", name: "YO L&M Standby - GT"}, 
        {value: "42708333", name: "YO L&M Dist -  Field Meet"}, 
        {value: "42708346", name: "YO L&M Trans - Field Meet"},                        
    ],
    "Sierra": [
        {value: "42910702", name: "SI Locate & Mark - Dist"}, 
        {value: "42910703", name: "SI Locate & Mark - GT"}, 
        {value: "42910704", name: "SI After Hours Locate & Mark"}, 
        {value: "42910705", name: "SI L&M Standby - Dist"}, 
        {value: "42910706", name: "SI L&M Standby - GT"}, 
        {value: "42708331", name: "SI L&M Dist -  Field Meet"}, 
        {value: "42708349", name: "SI L&M Trans - Field Meet"},                        
    ],
    "North Valley": [
        {value: "42910707", name: "NV Locate & Mark - Dist"}, 
        {value: "42910708", name: "NV Locate & Mark - GT"}, 
        {value: "42910709", name: "NV After Hours Locate & Mark"}, 
        {value: "42910710", name: "NV L&M Standby - Dist"}, 
        {value: "42910711", name: "NV L&M Standby - GT"}, 
        {value: "42708326", name: "NV L&M Dist -  Field Meet"}, 
        {value: "42708347", name: "NV L&M Trans - Field Meet"},                                  
    ],
    "Sonoma": [
        {value: "42910712", name: "SO Locate & Mark - Dist"}, 
        {value: "42910713", name: "SO Locate & Mark - GT"}, 
        {value: "42910714", name: "SO After Hours Locate & Mark"}, 
        {value: "42910715", name: "SO L&M Standby - Dist"}, 
        {value: "42910716", name: "SO L&M Standby - GT"}, 
        {value: "42708334", name: "SO L&M Dist -  Field Meet"}, 
        {value: "42708352", name: "SO L&M Trans - Field Meet"},                     
    ],
    "Humboldt": [
        {value: "42910717", name: "HB Locate & Mark - Dist"}, 
        {value: "42910718", name: "HB Locate & Mark - GT"}, 
        {value: "42910719", name: "HB After Hours Locate & Mark"}, 
        {value: "42910721", name: "HB L&M Standby - Dist"}, 
        {value: "42910722", name: "HB L&M Standby - GT"}, 
        {value: "42708335", name: "HB L&M Dist -  Field Meet"}, 
        {value: "42708351", name: "HB L&M Trans - Field Meet"},                        
    ],
}

export default PMNumbers;